import * as React from "react";
import {match, Redirect, Switch} from "react-router";
import RestrictedRoute from "./route/RestrictedRoute";
import {UserPermission} from "../model/user/UserPermission";
import TransactionWorkspaceContainer from "../components/v5/table/workspace/TransactionWorkspaceContainer";
import TransactionDetailsView from "../components/accounting/TransactionDetailsView";
import GeneralLedgerView from "../components/accounting/GeneralLedgerView";
import AccountsView from "../components/accounting/AccountsView";
import JournalView from "../components/accounting/JournalView";
import BillDetailsView from "../components/accounting/BillDetailsView";
import BillsView from "../components/accounting/BillsView";
import StripePayoutDetailsView from "../components/accounting/StripePayoutDetailsView";
import BillWorkspaceContainer from "../components/v5/workspace/BillWorkspaceContainer";
import GoCardlessPayoutDetailsView from "../components/accounting/GoCardlessPayoutDetailsView";
import EvChargingQuartersPage from "../components/evCharging/quarters/EvChargingQuartersPage";
import EvChargingQuarterPage from "../components/evCharging/quarters/EvChargingQuarterPage";

interface RouteProps {
	/**
	 * Route match url.
	 */
	match: match<any>;
}

/**
 * Accounting router view.
 */
export default class AccountingRouter extends React.PureComponent <RouteProps, {}> {

	render() {
		return (
			<Switch>
				<RestrictedRoute exact
								 path={this.props.match.url + "/transactions"}
								 component={TransactionWorkspaceContainer}
								 allowedPermissions={[UserPermission.AdminAll]}/>
				<RestrictedRoute path={this.props.match.url + "/transactions/:transactionId"}
								 component={TransactionDetailsView}
								 exact
								 allowedPermissions={[UserPermission.AdminAll]}/>
				<RestrictedRoute path={this.props.match.url + "/transactions/stripe_payout/:stripePayoutId"}
								 component={StripePayoutDetailsView}
								 exact
								 allowedPermissions={[UserPermission.AdminAll]}/>
				<RestrictedRoute path={this.props.match.url + "/transactions/gocardless_payout/:goCardlessPayoutId"}
								 component={GoCardlessPayoutDetailsView}
								 exact
								 allowedPermissions={[UserPermission.AdminAll]}/>
				<RestrictedRoute path={this.props.match.url + "/general_ledger"}
								 component={GeneralLedgerView}
								 exact
								 allowedPermissions={[UserPermission.AdminAll]}/>
				<RestrictedRoute path={this.props.match.url + "/accounts"}
								 component={AccountsView}
								 exact
								 allowedPermissions={[UserPermission.AdminAll]}/>
				<RestrictedRoute path={this.props.match.url + "/journal"}
								 component={JournalView}
								 exact
								 allowedPermissions={[UserPermission.AdminAll]}/>
				<RestrictedRoute path={this.props.match.url + "/bills/:billId"}
								 component={BillDetailsView}
								 allowedPermissions={[UserPermission.LeadEdit, UserPermission.LeadView]}/>
				<RestrictedRoute path={this.props.match.url + "/bills"}
								 component={BillsView}
								 exact
								 allowedPermissions={[UserPermission.AdminAll]}/>
				<RestrictedRoute exact
								 path={this.props.match.url + "/bills_workspace"}
								 component={BillWorkspaceContainer}
								 allowedPermissions={[UserPermission.AdminAll]}/>
				<RestrictedRoute exact
								 path={this.props.match.url + "/rtfo_submissions"}
								 component={EvChargingQuartersPage}
								 allowedPermissions={[UserPermission.AdminAll]}/>
				<RestrictedRoute exact
								 path={this.props.match.url + "/rtfo_submissions/:quarterId"}
								 component={EvChargingQuarterPage}
								 allowedPermissions={[UserPermission.AdminAll]}/>
				<Redirect to={this.props.match.url}/>
			</Switch>
		)
	}
}
